<div class="panel">
  <h1>{{'JUSTIFICATIONREASONS.Title' | translate}}</h1>
</div>
<hr>
  <div class="panel">
    <div class="container">
      <h4 style="text-align:left">{{'JUSTIFICATIONREASONS.Table' | translate}}</h4>

      <p-button type="button" [raised]="true" (click)="showDialog()"  icon="pi pi-plus" label="{{'JUSTIFICATIONREASONS.AddJustification' | translate}}" styleClass="ui-button-success"></p-button>
<hr>
      <p-table #tt [value]="justificationTypes" showGridlines [tableStyle]="{'table-layout':'auto'}" [globalFilterFields]="['Text']">

        <ng-template pTemplate="caption">
          <div class="row">
            <div class="col-sm-6">
              <input type="text" pInputText placeholder="{{'PROJECT.Filter' | translate}}" (input)="tt.filterGlobal($event.target.value, 'contains')"
                class="form-control">
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th scope="col" pSortableColumn="Text">{{'JUSTIFICATIONREASONS.JustificationReason' | translate}}<p-sortIcon field="text"></p-sortIcon>
            </th>
            <th scope="col" pSortableColumn="Enabled">{{'JUSTIFICATIONREASONS.Enabled' | translate}}<p-sortIcon field="enabled"></p-sortIcon>
            </th>
            <th scope="col">{{'JUSTIFICATIONREASONS.Options' | translate}}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-justificationType>
          <tr>
            <td>
              <p *ngIf="!justificationType.editable">{{justificationType.Text}}</p>
              <p *ngIf="justificationType.editable"><input type="text"class="wide-switch" pInputText placeholder="{{'JUSTIFICATIONREASONS.JustificationReason' | translate}}"
                  [(ngModel)]="justificationType.Text"></p>
            </td>
            <td>
              <p-toggleswitch [(ngModel)]="justificationType.isActive" (click)="toggleJustification(justificationType)"></p-toggleswitch>
            </td>
            <td>
              <div class="btn-container right">
                <p-button *ngIf="!justificationType.editable" icon="pi pi-pencil" [rounded]="true" [outlined]="true" styleClass="ui-button-primary ui-button-xs"
                  (click)="justificationType.editable = true"></p-button>
                <p-button *ngIf="justificationType.editable" icon="pi pi-save" [rounded]="true" severity="success" [outlined]="true" styleClass="ui-button-primary ui-button-xs"
                  (click)="saveJustification(justificationType)"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>


      <p-dialog header="{{'JUSTIFICATIONREASONS.AddJustificationReason' | translate}}" [(visible)]="displayAddDialog" showEffect="fade"
        [modal]="true">
        <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="justificationType">
          <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label for="text">{{'JUSTIFICATIONREASONS.Reason' | translate}}</label></div>
            <div class="ui-grid-col-8"><input class="wide-switch" pInputText id="vin" [(ngModel)]="justificationType.text" /></div>
          </div>
        </div>
        <ng-template #footer>
          <div class="d-grid gap-2 d-md-block">
            <button type="button" class="btn btn-danger me-2"  icon="fa fa-close" (click)="closeDialog()" >{{'JUSTIFICATIONREASONS.Cancel' | translate}}</button>
            <button type="button" class="btn btn-success"  icon="fa fa-check" (click)="createJustification()">{{'JUSTIFICATIONREASONS.Save' | translate}}</button>
          </div>
        </ng-template>
      </p-dialog>
    </div>
  </div>

